"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable dot-notation */
const react_1 = __importDefault(require("react"));
const SearchCatalogHeader_module_scss_1 = __importDefault(require("./SearchCatalogHeader.module.scss"));
function SearchCategoryHeader({ category, series, seriesType }) {
    return (react_1.default.createElement("div", { className: SearchCatalogHeader_module_scss_1.default['container'] },
        react_1.default.createElement("div", null,
            seriesType,
            " - ",
            category),
        react_1.default.createElement("div", null, series)));
}
exports.default = SearchCategoryHeader;
